<script lang="ts" setup>
import PaymentStatusResult from '@/modules/cashIn/components/PaymentStatusResult/index.vue';
import { useInswitchStatus } from './useInswitchStatus';

defineOptions({ name: 'InswitchStatus' });

const {
  status,
  transactionNumber,
  formattedAmount,
  handleGoHome,
  handleTryAgain,
} = useInswitchStatus();
</script>

<template>
  <PaymentStatusResult
    :status="status"
    :transaction-number="transactionNumber"
    :formatted-amount="formattedAmount"
    @go-home="handleGoHome"
    @try-again="handleTryAgain"
  />
</template>
